import React, { useRef, useEffect } from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { initializeSession, getUserDetail } from './app/store/slices/auth/authSlice';
import routes from './routes/routesConfig';
import Loader from './animation/Loader';

export default function App() {
    const dispatch = useDispatch();
    const { isLoggedIn, user, loading } = useSelector((state) => state.auth);
    const userDetailsFetched = useRef(false);

    // Initialize session only once
    useEffect(() => {
        dispatch(initializeSession());
    }, [dispatch]);

    // Fetch user details only once after login
    useEffect(() => {
        if (isLoggedIn && user?.uid && !userDetailsFetched.current) {
            userDetailsFetched.current = true;
            dispatch(getUserDetail(user.uid));
        }

        // Reset the ref when user logs out
        if (!isLoggedIn) {
            userDetailsFetched.current = false;
        }
    }, [isLoggedIn, user?.uid, dispatch]);

    return (
        <React.Fragment>
            {loading && <Loader />}
            <RouterProvider router={routes} />
            <ToastContainer
                position="bottom-right"
                hideProgressBar={false}
                draggable
                theme="dark"
                autoClose={false}
                limit={3}
                transition={Slide}
            />
        </React.Fragment>
    );
}
